import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { YoutubeNavbarComponent } from '../../../preview-common/youtube/youtube-navbar/youtube-navbar.component';

@Component({
    selector: 'app-gen-youtube-watch-ad',
    imports: [CommonModule, YoutubeNavbarComponent],
    templateUrl: './youtube-watch-ad.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['../../../preview-common/youtube/youtube-shared-styles.scss', './youtube-watch-ad.component.scss']
})
export class YouTubeWatchAdPreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** This placement's creative slot is the 1:1 square format. */
  readonly creativeFormat: CreativeFormat = 'square';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
